import React from 'react'
import AgencyBreadCrumb from './AgencyBreadCrumb';
import RenewableAgency from './RenewableAgency';

function RenewableAgencyPage() {
    return ( 
        <div className = "container-fluid">
            <AgencyBreadCrumb />
            <RenewableAgency />
        </div>
     );
}

export default RenewableAgencyPage;